import { http, HttpResponse } from 'msw';

import { mockGoogleWalletEligibleCard1 } from '../data/teGoogleWallet';
import { resource } from '../helpers';

export const teWalletHandlers = [
    http.get(resource('/wallets/google-pay'), async () => {
        return HttpResponse.json([mockGoogleWalletEligibleCard1]);
    }),
];
